import { ResizerMode } from "../resizer/ResizerMode";
import { ResizerScaleType } from "../resizer/ResizerScaleType";
import { PixiAppOptions } from "./PixiAppOptions";
import { UserAgent } from "../utils/UserAgent";
import { WebGlExtensionCheck } from "../utils/WebGlExtensionCheck";

/**
 */
export const DefaultOptionsApp: PixiAppOptions = {
  transparent: UserAgent.isKindle,
  forceCanvas: UserAgent.isLenovo,
  backgroundColor: 0xffffff,
  width: 1920,
  height: 1440,
  autoStart: true,
  antialias: false,
  forceFXAA: true,
  //legacy: true,
  maxWidth: 3040,
  minWidth: 0,
  resizerMode: ResizerMode.Aspect,
  scaleType: ResizerScaleType.Stage,
  view: undefined,
  preserveDrawingBuffer: WebGlExtensionCheck.frameBufferSupportCheck(),
  scaleFactor: 1,
  clearBeforeRender: true,
  //roundPixels: false,
  powerPreference: "high-performance",
  sharedTicker: true,
  sharedLoader: true,
  resolution: 1,
  contextMenuEnabled: false,
  buttonsRequestFullscreen: false,
  fullscreenTargetElement: undefined,
  maxPixelRatio: 2,
  lockScroll: true
};
